/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, use } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import { Box, Typography, IconButton, Button, Select, MenuItem } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { X } from "lucide-react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";

const childArr = [
  { name: "1 year", value: "1" },
  { name: "2 year", value: "2" },
  { name: "3 year", value: "3" },
  { name: "4 year", value: "4" },
  { name: "5 year", value: "5" },
  { name: "6 year", value: "6" },
  { name: "7 year", value: "7" },
  { name: "8 year", value: "8" },
  { name: "9 year", value: "9" },
  { name: "10 year", value: "10" },
  { name: "11 year", value: "11" },
  { name: "12 year", value: "12" },
  // { name: "13 year old", value: "13" },
  // { name: "14 year old", value: "14" },
  // { name: "15 year old", value: "15" },
  // { name: "16 year old", value: "16" },
  // { name: "17 year old", value: "17" },
];

const counters = [
  // { name: "Adults", defaultValue: 2 },
  // { name: "Children", defaultValue: 1 },
  { name: "Rooms", defaultValue: 1 },
];

const Counter = ({
  guetsValue,
  name,
  defaultValue,
  onCounterChange,
  setChildAge,
  childAge,
  setPaxRooms,
  handleChangeChildAge,
  error,
  setError,
}) => {
  const [count, setCount] = useState(defaultValue);

  const calculateRooms = (adultsCount) => {
    const maxAdultsPerRoom = 6;
    return Math.ceil(adultsCount / maxAdultsPerRoom);
  };

  const calculateMaxChildren = (roomCount) => {
    const maxChildrenPerRoom = 4;
    return roomCount * maxChildrenPerRoom;
  };

  const incrementCount = () => {
    if (name === "Children" && guetsValue.Rooms > 0) {
      const maxChildren = calculateMaxChildren(guetsValue.Rooms);
      if (defaultValue >= maxChildren) {
        return;
      }
    }

    setCount(defaultValue + 1);
    onCounterChange(name, defaultValue + 1);

    if (name === "Adults") {
      const roomCount = calculateRooms(defaultValue + 1);
      onCounterChange("Rooms", roomCount);
    }
  };

  const decrementCount = () => {
    if (name !== "Children" && defaultValue - 1 < 1) {
      return; // Don't decrement below 1 for Adults and Rooms
    }

    if (name === "Children" && defaultValue - 1 < 0) {
      return; // Don't decrement below 0 for Children
    }

    setCount(defaultValue - 1);
    onCounterChange(name, defaultValue - 1);

    // If the counter is for adults, update the room count as well
    if (name === "Adults") {
      const roomCount = calculateRooms(defaultValue - 1);
      onCounterChange("Rooms", roomCount);
    }

    if (
      name === "Rooms" &&
      defaultValue - 1 < guetsValue.Adults / maxAdultsPerRoom
    ) {
      const newAdultCount = (defaultValue - 1) * maxAdultsPerRoom;
      setCount(newAdultCount);
      onCounterChange("Adults", newAdultCount);
    }

    // If the counter is for children, update the maximum children count based on the updated room count
    if (name === "Children" && guetsValue.Rooms > 0) {
      const maxChildren = calculateMaxChildren(guetsValue.Rooms);
      if (defaultValue > maxChildren) {
        setCount(maxChildren);
        onCounterChange(name, maxChildren);
      }
    }
    // }
  };

  const maxAdultsPerRoom = 6;
  let adultCount = guetsValue.Adults; // replace with actual adult count
  useEffect(() => {
    // When the room count is set to 1, ensure that only up to 4 children ages are shown
    if (guetsValue.Rooms === 1 && name === "Children" && defaultValue > 4) {
      setCount(4);
      onCounterChange(name, 4);
    }
  }, [guetsValue.Rooms, name, defaultValue]);

  useEffect(() => {
    const PaxRooms = distributeGuests(
      guetsValue.Adults,
      guetsValue.Children,
      guetsValue.Rooms,
      childAge
    );
  }, [guetsValue]);

  useEffect(() => {
    const paxRooms = additionalCounters.slice(1);
  }, [guetsValue]);

  const [additionalCounters, setAdditionalCounters] = useState([]);

  const handleAddCounter = () => {
    setAdditionalCounters((prevCounters) => [
      ...prevCounters,

      {
        name: `Room ${additionalCounters.length + 1}`,
        adults: 1, // Initial adult count
        children: 0, // Initial child count
      },
    ]);
  };

  return (
    <>
      <div className="row y-gap-10 justify-between items-center">
        <div className="col-auto">
          <div className="text-15 lh-12 fw-500">{name}</div>
          <p> {error?.adult}</p>
          {name === "Children" && defaultValue > 0 && (
            <div className="text-14 lh-12 text-light-1 mt-5">
              Ages of Children at Time of Check-in *
            </div>
          )}
        </div>
        {/* End .col-auto */}
        <div className="col-auto">
          <div className="d-flex items-center js-counter">
            <button
              className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-down"
              onClick={decrementCount}
            >
              <i className="icon-minus text-12" />
            </button>
            {/* decrement button */}
            <div className="flex-center size-20 ml-15 mr-15">
              <div className="text-15 js-count">{defaultValue}</div>
            </div>

            <button
              className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-up"
              onClick={handleAddCounter}
            >
              <i className="icon-plus text-12" />
            </button>

            {/* increment button */}
          </div>
        </div>
        <Grid container spacing={3}>
          {name === "Children" &&
            childAge !== null &&
            childAge?.map((child, i) => (
              <Grid item key={i}>
                <Autocomplete
                  disablePortal
                  id={`combo-box-demo-${i}`}
                  options={childArr}
                  value={child}
                  onChange={(e, newvalue) =>
                    handleChangeChildAge(e, newvalue, i)
                  }
                  getOptionLabel={(option) =>
                    `${option.name} - ${option.value}`
                  }
                  sx={{ width: 150 }}
                  renderInput={(params) => (
                    <TextField {...params} label="Age" />
                  )}
                />
              </Grid>
            ))}
        </Grid>
        {/* End .col-auto */}
      </div>
      {/* End .row */}
      <div className="border-top-light mt-24 mb-24" />
    </>
  );
};

// const distributeGuests = (totalAdults, totalChildren, roomCount, childAges) => {
//   const paxRooms = [];

//   let remainingAdults = totalAdults;
//   let remainingChildren = totalChildren;

//   // First loop: Initialize rooms with at least 1 adult each
//   for (let i = 0; i < roomCount && remainingAdults > 0; i++) {
//     const adultsInRoom = Math.min(remainingAdults, 1);
//     const childrenAgesInRoom = childAges?.slice(i * 4, (i + 1) * 4);
//     const childrenInRoom = Math.min(
//       remainingChildren,
//       childrenAgesInRoom?.length
//     );

//     const childrenAges = childrenAgesInRoom
//       ?.slice(0, childrenInRoom)
//       ?.map((age) => parseInt(age.value, 10));

//     paxRooms.push({
//       Adults: adultsInRoom,
//       Children: childrenInRoom,
//       ChildrenAges: childrenAges,
//     });

//     remainingAdults -= adultsInRoom;
//     remainingChildren -= childrenInRoom;
//   }

//   // Second loop: Distribute remaining adults
//   for (let i = 0; remainingAdults > 0 && i < paxRooms.length; i++) {
//     const adultsToAdd = Math.min(remainingAdults, 7); // Distribute the rest, but not more than 7

//     paxRooms[i].Adults += adultsToAdd;
//     remainingAdults -= adultsToAdd;
//   }

//   return paxRooms;
// };

const distributeGuests = (totalAdults, totalChildren, roomCount, childAges) => {
  const paxRooms = [];

  for (let i = 0; i < roomCount; i++) {
    // For simplicity, assume each room has the same number of adults and children
    paxRooms.push({
      Adults: totalAdults,
      Children: totalChildren,
      ChildrenAges: childAges
        ? childAges
          .slice(i * 4, (i + 1) * 4)
          .map((age) => (age && age.value ? parseInt(age.value, 10) : null))
        : [],
    });
  }

  return paxRooms;
};

const GuestSearch = ({
  guetsValue = { Adults: 1, Children: 0, Rooms: 1 },
  setGuestValue,
  childAge = [],
  setChildAge = () => { },
  additionalCounters = [],
  setAdditionalCounters,
}) => {
  const [error, setError] = useState({
    adult: "",
    children: "",
    room: "",
  });
  const [expanded, setExpanded] = useState(additionalCounters?.length === 1 ? 0 : null);
  const [errorMessage, setErrorMessage] = useState("");
  // const [count, setCount] = useState(
  //   guetsValue.Rooms !== undefined ? guetsValue.Rooms : 1
  // );
  const [count, setCount] = useState(
    guetsValue?.Rooms !== undefined ? guetsValue?.Rooms : 1
  );


  useEffect(() => {
    if (guetsValue?.Rooms) {
      setCount(guetsValue?.Rooms);
    }
  }, [guetsValue])

  const maxRoom = 6;
  const maxChildPerRoom = 4;
  const maxAdultsPerRoom = 6;

  useEffect(() => {
    if (guetsValue && guetsValue.Children > 0) {
      const myTempArr = [];
      for (let j = 0; j < guetsValue.Children; j++) {
        myTempArr.push(
          childAge[j] ? childAge[j] : { name: "1 year", value: "1" }
        );
      }
      setChildAge(myTempArr);
    } else {
      setChildAge([]);
    }
  }, [guetsValue]);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentEditingRoom, setCurrentEditingRoom] = useState(0);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleRoomCountChange = (value) => {
    if (value < 1) {
      setErrorMessage("Minimum room count is 1");
      return;
    } else if (value > maxRoom) {
      setErrorMessage(
        `Maximum room count exceeded. Maximum allowed: ${maxRoom}`
      );
      return;
    }
    setErrorMessage("");
    if (value > additionalCounters.length) {
      const newCounters = [];
      for (let i = additionalCounters.length + 1; i <= value; i++) {
        newCounters.push({
          name: `Room ${i}`,
          adults: 1,
          children: 0,
          childrenAges: [],
          Rooms: value,
        });
      }
      setAdditionalCounters((prevCounters) => [
        ...prevCounters,
        ...newCounters,
      ]);
      setCurrentEditingRoom(additionalCounters.length); // Open the newly added room for editing
    } else if (value < additionalCounters.length) {
      setAdditionalCounters((prevCounters) => prevCounters.slice(0, value));
      setCurrentEditingRoom(value - 1);
    }
    setGuestValue((prevValue) => ({
      ...prevValue,
      Rooms: value,
      Adults: value,
    }));

    setCount(value);
  };

  const handleAdultCountChange = (value, index) => {
    if (value < 1) {
      setErrorMessage("Minimum adult count per room is 1.");
      value = 1;
    } else if (value > maxAdultsPerRoom) {
      setErrorMessage(
        `Maximum adult count per room exceeded. Maximum allowed: ${maxAdultsPerRoom}`
      );
      value = maxAdultsPerRoom;
    } else {
      setErrorMessage("");
    }
    setAdditionalCounters((prevCounters) => {
      const updatedCounters = [...prevCounters];
      updatedCounters[index].adults = value;
      const totalAdults = updatedCounters.reduce(
        (acc, counter) => acc + counter.adults,
        0
      );
      setGuestValue((prevValue) => ({
        ...prevValue,
        Adults: totalAdults,
      }));
      return updatedCounters;
    });
  };

  const handleChildCountChange = (value, index) => {
    if (value < 0) {
      setErrorMessage("");
      return;
    } else if (value > maxChildPerRoom) {
      setErrorMessage(
        `Maximum child count per room exceeded. Maximum allowed: ${maxChildPerRoom}`
      );
      // setError((prevError) => ({
      //   ...prevError,
      //   children: `Maximum child count per room exceeded. Maximum allowed: ${maxChildPerRoom}`,
      // }));
      value = maxChildPerRoom;
    } else {
      setErrorMessage("");
      // setError((prevError) => ({
      //   ...prevError,
      //   children: "",
      // }));
    }

    setAdditionalCounters((prevCounters) => {
      const updatedCounters = [...prevCounters];
      updatedCounters[index].children = value;

      // Update childrenAges for each child
      const newChildrenAges = Array.from({ length: value }, () => ({
        name: "1 year",
        value: "1",
      }));
      updatedCounters[index].childrenAges = newChildrenAges;

      // Calculate total children across all counters
      const totalChildren = updatedCounters.reduce(
        (acc, counter) => acc + counter.children,
        0
      );
      setGuestValue((prevValue) => ({
        ...prevValue,
        Children: totalChildren,
      }));
      return updatedCounters;
    });
  };

  const handleChildAgesChange = (value, roomIndex, childIndex) => {
    setAdditionalCounters((prevCounters) => {
      const updatedCounters = prevCounters.map((counter, index) => {
        if (index === roomIndex) {
          const updatedChildrenAges = [...counter.childrenAges];
          updatedChildrenAges[childIndex] = { name: childArr.find(opt => opt.value === value)?.name || "", value };

          return {
            ...counter,
            childrenAges: updatedChildrenAges,
          };
        }
        return counter;
      });

      // Calculate total children count
      const totalChildren = updatedCounters.reduce((acc, counter) => acc + counter.childrenAges.length, 0);

      setGuestValue((prevValue) => ({
        ...prevValue,
        ChildrenAges: totalChildren,
      }));

      return updatedCounters;
    });
  };


  const handleEditRoom = (roomIndex) => {
    setCurrentEditingRoom(roomIndex);
  };

  const handleDeleteRoom = (roomIndex) => {
    if (count === 1) {
      setErrorMessage("Minimum room count is 1.");
      return;
    }
    setAdditionalCounters((prevCounters) =>
      prevCounters.filter((_, index) => index !== roomIndex)
    );
    setCount((prevCount) => prevCount - 1);
    setGuestValue((prevValue) => ({
      ...prevValue,
      Rooms: count - 1,
    }));
    setCurrentEditingRoom(roomIndex.length - 1);
  };


  const handleAccordionChange = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <div className="input-style w-100 h-40 searchMenu-guests px-20 d-flex items-center sm:px-20 js-form-dd js-form-counters position-relative">
      <div
        data-bs-toggle="dropdowns"
        data-bs-auto-close="outside"
        aria-expanded="false"
        data-bs-offset="0,22"
        onClick={handleOpenModal}
      >
        <p className="text-12 fw-500 ls-2 lh-16">Guests and Rooms</p>
        <div className="text-15 text-light-1 ls-2 lh-16">
          <span className="js-count-adult">
            {(additionalCounters || []).reduce(
              (acc, counter) => acc + counter.adults,
              0
            )}
          </span>{" "}
          adults -{" "}
          <span className="js-count-child">
            {(additionalCounters || []).reduce(
              (acc, counter) => acc + counter.children,
              0
            )}
          </span>{" "}
          children - <span className="js-count-room">{count}</span> rooms
        </div>
      </div>

      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="guests-and-rooms-modal"
        aria-describedby="modal-with-guests-and-rooms-selection"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="modal-content stay-holi-modal">
          <div className="modal-body">
            <div className="bg-white p-3 rounded-4 counter-box">
              <div className="d-flex flex-column gap-4">

                <div className="guest-selector" style={{
                  display: "flex",
                  justifyContent: "space-between"
                }}>
                  <Typography style={{
                    textAlign: "start",
                    fontSize: "24px",
                    fontWeight: "600"
                  }}>Select Your Rooms</Typography>
                  <div display="flex" justifyContent="end" sx={{ position: "absolute", top: "0px", right: "0px" }}>
                    <Button onClick={handleCloseModal} sx={{ color: 'black' }}>
                      <X size={26} />
                    </Button>
                  </div>
                </div>

                {errorMessage && (
                  <div style={{ color: "red" }}>{errorMessage}</div>
                )}
                <div className="d-flex justify-content-between align-items-center" style={{
                  background: "#6dc8bf1f",
                  padding: "10px", borderRadius: '5px'
                }}>
                  <div className="d-flex gap-2 align-items-center">
                    <Typography fontWeight={600}>Add Room</Typography>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "#fff", padding: "5px 10px", borderRadius: "8px" }}>
                      <IconButton size="small" style={{ border: "1px solid #45baae", borderRadius: "5px", cursor: "pointer" }} onClick={() => handleRoomCountChange(count - 1)}>
                        <RemoveIcon fontSize="small" />
                      </IconButton>

                      <Typography>{count}</Typography>

                      <IconButton size="small" onClick={() => handleRoomCountChange(count + 1)} style={{ backgroundColor: "#44b9ae", color: "#fff", borderRadius: "5px", cursor: "pointer" }}>
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </div>
                  <Button variant="contained" style={{ borderRadius: "8px", backgroundColor: "#6dc8bf" }} onClick={handleCloseModal}>
                    Submit
                  </Button>

                </div>


                {/* <div className="d-flex justify-content-between align-items-center">
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Select Rooms
                  </Typography>
                  <div className="d-flex gap-3">
                    <button
                      className="button -outline-blue-1 text-blue-1 rounded-4 js-down"
                      style={{ width: "35px", height: "35px" }}
                      onClick={() => handleRoomCountChange(count - 1)}
                    >
                      <i className="icon-minus text-12" />
                    </button>
                    <div className="text-15">{count}</div>
                    <button
                      className="button -outline-blue-1 text-blue-1 rounded-4 js-up"
                      style={{ width: "35px", height: "35px" }}
                      onClick={() => handleRoomCountChange(count + 1)}
                    >
                      <i className="icon-plus text-12" />
                    </button>
                  </div>
                </div> */}

                <div
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    padding: "10px 0px",
                    display: "grid",
                    gap: "10px",
                    /* Hide Scrollbar */
                    scrollbarWidth: "none",  /* Firefox */
                    msOverflowStyle: "none", /* Internet Explorer/Edge */
                  }}
                >
                  {additionalCounters.map((counter, roomIndex) => (
                    <div key={roomIndex} className={`d-flex gap-1 ${expanded === roomIndex ? "align-items-start" : "align-items-center"}`}>
                      <Accordion
                        key={roomIndex}
                        expanded={expanded === roomIndex}
                        onChange={() => handleAccordionChange(roomIndex)}
                        style={{ width: "100%", borderRadius: "8px", border: "1px solid #7575753b" }}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`room-3-content`}
                          id={`room-3-header`}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {/* Left Side - Room Icon and Details */}
                          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                            {/* Bed Icon with Lamp */}
                            <img
                              src="/icon/rooms.svg"
                              alt="bed"
                              style={{ width: "40px", height: "40px" }}
                            />

                            {/* Room Details */}
                            <div className="text-start">
                              <Typography fontWeight={600}>{`Room ${roomIndex + 1}`}</Typography>
                              <Typography variant="body2" color="gray">
                                {`Adult-${counter.adults}`} | {`Children-${counter.children}`}
                              </Typography>
                            </div>
                          </div>
                        </AccordionSummary>

                        <AccordionDetails style={{
                          background: "#f6f6f696"
                        }}>
                          <div className="d-flex justify-content-between">
                            {/* Left Side - Label */}
                            <div className="text-start">
                              <Typography fontWeight={600}>Adult</Typography>
                              <Typography variant="body2" color="gray">
                                Age 12+
                              </Typography>
                            </div>

                            {/* Counter Section */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "#f9f9f9", padding: "5px 10px", borderRadius: "8px" }}>
                              <IconButton size="small" style={{ border: "1px solid #45baae", borderRadius: "5px", cursor: "pointer" }} onClick={() => handleAdultCountChange(counter.adults - 1, roomIndex)}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>

                              <Typography>{counter?.adults}</Typography>

                              <IconButton size="small" style={{ backgroundColor: "#44b9ae", color: "#fff", borderRadius: "5px", cursor: "pointer" }} onClick={() => handleAdultCountChange(counter.adults + 1, roomIndex)}>
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </div>
                        </AccordionDetails>
                        <AccordionDetails style={{
                          background: "#f6f6f696",
                          borderTop: "0.2px solid #a5a1a196"
                        }}>
                          <div className="d-flex justify-content-between">
                            {/* Left Side - Label */}
                            <div className="text-start">
                              <Typography fontWeight={600}>Children</Typography>
                              <Typography variant="body2" color="gray">
                                Age 0-12
                              </Typography>
                            </div>

                            {/* Counter Section */}
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", background: "#f9f9f9", padding: "5px 10px", borderRadius: "8px" }}>
                              <IconButton size="small" style={{ border: "1px solid #45baae", borderRadius: "5px", cursor: "pointer" }} onClick={() => handleChildCountChange(counter.children - 1, roomIndex)} >
                                <RemoveIcon fontSize="small" />
                              </IconButton>

                              <Typography>{counter?.children}</Typography>

                              <IconButton size="small" style={{ backgroundColor: "#44b9ae", color: "#fff", borderRadius: "5px", cursor: "pointer" }} onClick={() => handleChildCountChange(counter.children + 1, roomIndex)}>
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </div>
                          <Box mt={2} className="d-flex flex-wrap gap-4">
                            {Array.from({ length: counter.children }, (item, childIndex) => (
                              // <div key={childIndex} className="d-flex gap-3 align-items-center">
                              //   <label htmlFor={`autocomplete-${roomIndex}-${childIndex}`}>Age {childIndex + 1}</label>
                              //   <Autocomplete
                              //     disablePortal
                              //     id={`autocomplete-${roomIndex}-${childIndex}`}
                              //     options={childArr}
                              //     onChange={(e, newValue) => handleChildAgesChange(newValue, roomIndex, childIndex)}
                              //     value={counter.childrenAges[childIndex] || { name: "1 year old", value: "1" }}
                              //     getOptionLabel={(option) => `${option.name}`}
                              //     style={{ width: 130 }}
                              //     renderInput={(params) => <TextField {...params} />}
                              //     size="small"
                              //   />
                              // </div>
                              <div key={childIndex} className="d-flex gap-3 align-items-center">
                                <label htmlFor={`select-${roomIndex}-${childIndex}`}>Age {childIndex + 1}</label>
                                <Select
                                  id={`select-${roomIndex}-${childIndex}`}
                                  value={counter.childrenAges[childIndex]?.value || "1"}
                                  onChange={(e) => handleChildAgesChange(e.target.value, roomIndex, childIndex)}
                                  displayEmpty
                                  style={{ width: 130 }}
                                >
                                  {childArr.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                      {option.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </div>
                            ))}
                          </Box>
                        </AccordionDetails>

                      </Accordion>
                      {
                        additionalCounters?.length > 1 &&
                        <div>
                          <IconButton
                            onClick={() => handleDeleteRoom(roomIndex)}
                            size="small"
                            sx={{
                              "&:hover": {
                                color: "red",
                                background: "#f2a3a36e" // Changes color on hover
                              },
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>

                        </div>
                      }
                    </div>
                  ))}</div>

                {/* {errorMessage && (
                  <div style={{ color: "red", marginTop: "20px" }}>
                    {errorMessage}
                  </div>
                )} */}

                {/* <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Done
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
    // <div className="searchMenu-guests px-20 d-flex items-center sm:px-20 js-form-dd js-form-counters position-relative">
    //   <div
    //     data-bs-toggle="dropdowns"
    //     data-bs-auto-close="outside"
    //     aria-expanded="false"
    //     data-bs-offset="0,22"
    //     onClick={handleOpenModal}
    //   >
    //     <p className="text-12 fw-500 ls-2 lh-16">Guests and Rooms</p>
    //     <div className="text-15 text-light-1 ls-2 lh-16">
    //       <span className="js-count-adult">
    //         {additionalCounters.reduce((acc, counter) => acc + counter.adults, 0)}
    //       </span>{" "}
    //       adults -{" "}
    //       <span className="js-count-child">
    //         {additionalCounters.reduce((acc, counter) => acc + counter.children, 0)}
    //       </span>{" "}
    //       children - <span className="js-count-room">{count}</span> rooms
    //     </div>
    //   </div>

    //   <Modal
    //     open={modalOpen}
    //     onClose={handleCloseModal}
    //     aria-labelledby="guests-and-rooms-modal"
    //     aria-describedby="modal-with-guests-and-rooms-selection"
    //     style={{
    //       display: "flex",
    //       alignItems: "center",
    //       justifyContent: "center",
    //     }}
    //   >
    //     <div
    //       className="modal-content"
    //       style={{ maxWidth: "50%", maxHeight: "500px", overflowY: "auto" }}
    //     >
    //       <div className="modal-body">
    //         <div className="bg-white p-5 rounded-4 counter-box">
    //           <div className="d-flex flex-column gap-3">
    //             <div className="d-flex justify-content-between align-items-center">
    //               <Typography>Select Rooms</Typography>
    //               <div className="d-flex gap-3">
    //                 <button
    //                   className="button -outline-blue-1 text-blue-1 rounded-4 js-down"
    //                   style={{ width: "35px", height: "35px" }}
    //                   onClick={() => handleRoomCountChange(count - 1)}
    //                 >
    //                   <i className="icon-minus text-12" />
    //                 </button>
    //                 <div className="text-15">{count}</div>
    //                 <button
    //                   className="button -outline-blue-1 text-blue-1 rounded-4 js-up"
    //                   style={{ width: "35px", height: "35px" }}
    //                   onClick={() => handleRoomCountChange(count + 1)}
    //                 >
    //                   <i className="icon-plus text-12" />
    //                 </button>
    //               </div>
    //             </div>
    //             {additionalCounters.map((counter, roomIndex) => (
    //               <Paper
    //                 key={roomIndex}
    //                 elevation={3}
    //                 className="counter-box"
    //                 style={{ padding: "15px", marginTop: "20px", position: "relative" }}
    //               >
    //                 <div className="d-flex justify-content-end gap-1" style={{ position: "absolute", top: "10px", right: "10px" }}>
    //                   <IconButton onClick={() => handleEditRoom(roomIndex)} size="small">
    //                     <EditIcon />
    //                   </IconButton>
    //                   <IconButton onClick={() => handleDeleteRoom(roomIndex)} size="small">
    //                     <DeleteIcon />
    //                   </IconButton>
    //                 </div>

    //                 {currentEditingRoom === roomIndex ? (
    //                   <div className="d-flex flex-column gap-3">
    //                     <Typography>{`Room ${roomIndex + 1}`}</Typography>
    //                     <div className="d-flex justify-content-between align-items-center">
    //                       <Typography>Adults</Typography>
    //                       <div className="d-flex gap-3">
    //                         <button
    //                           className="button -outline-blue-1 text-blue-1 rounded-4 js-down"
    //                           style={{ width: "35px", height: "35px" }}
    //                           onClick={() => handleAdultCountChange(counter.adults - 1, roomIndex)}
    //                         >
    //                           <i className="icon-minus text-12" />
    //                         </button>
    //                         <div className="text-15">{counter.adults}</div>
    //                         <button
    //                           className="button -outline-blue-1 text-blue-1 rounded-4 js-up"
    //                           style={{ width: "35px", height: "35px" }}
    //                           onClick={() => handleAdultCountChange(counter.adults + 1, roomIndex)}
    //                         >
    //                           <i className="icon-plus text-12" />
    //                         </button>
    //                       </div>
    //                     </div>
    //                     <div className="d-flex justify-content-between align-items-center">
    //                       <Typography>Children</Typography>
    //                       <div className="d-flex gap-3">
    //                         <button
    //                           className="button -outline-blue-1 text-blue-1 rounded-4 js-down"
    //                           style={{ width: "35px", height: "35px" }}
    //                           onClick={() => handleChildCountChange(counter.children - 1, roomIndex)}
    //                         >
    //                           <i className="icon-minus text-12" />
    //                         </button>
    //                         <div className="text-15">{counter.children}</div>
    //                         <button
    //                           className="button -outline-blue-1 text-blue-1 rounded-4 js-up"
    //                           style={{ width: "35px", height: "35px" }}
    //                           onClick={() => handleChildCountChange(counter.children + 1, roomIndex)}
    //                         >
    //                           <i className="icon-plus text-12" />
    //                         </button>
    //                       </div>
    //                     </div>
    //                     {counter.children > 0 && (
    //                       <div>
    //                         <Typography>Children's Ages</Typography>
    //                         {Array.from({ length: counter.children }).map((_, childIndex) => (
    //                           <Autocomplete
    //                             key={childIndex}
    //                             options={[
    //                               { name: "1 year old", value: "1" },
    //                               { name: "2 years old", value: "2" },
    //                               { name: "3 years old", value: "3" },
    //                               { name: "4 years old", value: "4" },
    //                               { name: "5 years old", value: "5" },
    //                               { name: "6 years old", value: "6" },
    //                               { name: "7 years old", value: "7" },
    //                               { name: "8 years old", value: "8" },
    //                               { name: "9 years old", value: "9" },
    //                               { name: "10 years old", value: "10" },
    //                               { name: "11 years old", value: "11" },
    //                               { name: "12 years old", value: "12" },
    //                               { name: "13 years old", value: "13" },
    //                               { name: "14 years old", value: "14" },
    //                               { name: "15 years old", value: "15" },
    //                             ]}
    //                             getOptionLabel={(option) => option.name}
    //                             value={counter.childrenAges[childIndex] || { name: "1 year old", value: "1" }}
    //                             onChange={(event, newValue) => handleChildAgesChange(newValue, roomIndex, childIndex)}
    //                             renderInput={(params) => (
    //                               <TextField
    //                                 {...params}
    //                                 variant="outlined"
    //                                 placeholder="Select Age"
    //                               />
    //                             )}
    //                           />
    //                         ))}
    //                       </div>
    //                     )}
    //                   </div>
    //                 ) : (
    //                   <div>
    //                     <Typography>{`Room ${roomIndex + 1}`}</Typography>
    //                     <div className="d-flex justify-content-between">
    //                       <Typography>Adults: {counter.adults}</Typography>
    //                       <Typography>Children: {counter.children}</Typography>
    //                     </div>
    //                     {counter.children > 0 && (
    //                       <div>
    //                         <Typography>Children's Ages</Typography>
    //                         <ul>
    //                           {counter.childrenAges.map((age, index) => (
    //                             <li key={index}>{age.name}</li>
    //                           ))}
    //                         </ul>
    //                       </div>
    //                     )}
    //                   </div>
    //                 )}
    //               </Paper>
    //             ))}
    //           </div>
    //           <div>
    //             <button
    //               className="button -outline-blue-1 text-blue-1 rounded-4 js-down"
    //               style={{ width: "35px", height: "35px" }}
    //               onClick={() => handleRoomCountChange(count - 1)}
    //             >
    //               <i className="icon-minus text-12" />
    //             </button>
    //             <div className="text-15">{count}</div>
    //             <button
    //               className="button -outline-blue-1 text-blue-1 rounded-4 js-up"
    //               style={{ width: "35px", height: "35px" }}
    //               onClick={() => handleRoomCountChange(count + 1)}
    //             >
    //               <i className="icon-plus text-12" />
    //             </button>
    //           </div>
    //         </div>
    //         {errorMessage && <div className="error-message">{errorMessage}</div>}
    //       </div>
    //     </div>
    //   </Modal>
    // </div>
  );
};

export default GuestSearch;
